import Vue from 'vue'

var config = {
  interface: "/API/",
  interface1: "/API/",
  upload: "/API/picture/uploadPicture",
  popularizationUpload: '/API/upload/health/uploadImage',
  uploadVideo: "/API/picture/uploadVideo",
  uploadHealthVideo: "/API/upload/health/uploadVideo",
  uploadHealthImage: "/API/upload/health/uploadImage",
  // zhonghe: "https://hlwtest.gooeto.com/commonAPI/",
  upload1: "/mediaAPI/image/upload/doctorApp",
  upload2: "/API/picture/uploadOssCdn",
  chronic: "/chronicAPI",
  shop: "/mallAPI",
  zml: "/zmlAPI/",
  ihAPI:'/ihAPI'
};
configadmin.upload = '/fileAPI/submissionPlatform/user/question'

if (process.env.NODE_ENV != 'production') {
  let extension = location.href.split('/')[2].split('.')
  let urlextension = '.' + extension[1] + '.' + extension[2]
  for (var key in config) {
    var reg = new RegExp('.gooeto.com', 'g')
    config[key] = config[key].replace(reg, urlextension)
  }

  for (var key in configadmin) {
    var reg = new RegExp('.gooeto.com', 'g')
    configadmin[key] = configadmin[key].replace(reg, urlextension)
  }
}

Vue.prototype.$ = $
Vue.prototype.$get = function(url, data) {
  return $.ajax({
    type: 'GET',
    data: data,
    url: url,
    headers: { Authorization: 'Bearer ' + window.localStorage.getItem('token') },
    xhrFields: {
      withCredentials: true
    }
  }).then(item => {
    item.token && $vue.$store.commit('userinfo/setHttpToken', item.token)
    if (item.code == 200) {
      return item
    } else {
      this.$message({ message: (item.mes || item.msg), type: 'warning', duration: 3000 })
    }
  }).catch(item => {
    if (item.status != 401) {
      this.$message({ message: (item.mes || item.msg), type: 'warning', duration: 3000 })
    }
  })
}

Vue.prototype.$post = async function(url, data) {
  return await $.ajax({
    url: url,
    type: 'POST',
    data: data,
    headers: { Authorization: 'Bearer ' + window.localStorage.getItem('token') },
    xhrFields: {
      withCredentials: true
    }
  }).then(item => {
    if (item.code == 200) {
      item.token && $vue.$store.commit('userinfo/setHttpToken', item.token)
      return item
    } else {
      this.$message({ message: (item.mes || item.msg), type: 'warning', duration: 3000 })
    }
  }).catch(item => {
    if (item.status != 401) {
      this.$message({ message: (item.mes || item.msg), type: 'warning', duration: 3000 })
    }
  })
}
Vue.prototype.$postJson = async function(url, data) {
  return await $.ajax({
    url: url,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(data),
    headers: { Authorization: 'Bearer ' + window.localStorage.getItem('token') },
    xhrFields: {
      withCredentials: true
    }
  }).then(item => {
    if (item.code == 200) {
      item.token && $vue.$store.commit('userinfo/setHttpToken', item.token)
      return item
    } else {
      this.$message({ message: (item.mes || item.msg), type: 'warning', duration: 3000 })
    }
  }).catch(item => {
    if (item.status != 401) {
      this.$message({ message: (item.mes || item.msg), type: 'warning', duration: 3000 })
    }
  })
}

Vue.prototype.$put = async function(url, data) {
  return await $.ajax({
    url: url,
    type: 'POST',
    data: data,
    headers: { Authorization: 'Bearer ' + window.localStorage.getItem('token') },
    xhrFields: {
      withCredentials: true
    }
  }).then(item => {
    if (item.code == 200) {
      item.token && $vue.$store.commit('userinfo/setHttpToken', item.token)
      return item
    } else {
      this.$message({ message: (item.mes || item.msg), type: 'warning', duration: 3000 })
    }
  }).catch(item => {
    if (item.status != 401) {
      this.$message({ message: (item.mes || item.msg), type: 'warning', duration: 3000 })
    }
  })
}

Vue.prototype.$delete = async function(url, data) {
  return await $.ajax({
    url: url,
    type: 'POST',
    data: data,
    headers: { Authorization: 'Bearer ' + window.localStorage.getItem('token') },
    xhrFields: {
      withCredentials: true
    }
  }).then(item => {
    console.log(item)
    if (item.code == 200) {
      item.token && $vue.$store.commit('userinfo/setHttpToken', item.token)
      return item
    } else {
      this.$message({ message: (item.mes || item.msg), type: 'warning', duration: 3000 })
    }
  }).catch(item => {
    if (item.status != 401) {
      this.$message({ message: (item.mes || item.msg), type: 'warning', duration: 3000 })
    }
  })
}

Vue.prototype.config = config

function formatTen(num) {
  return num > 9 ? (num + '') : ('0' + num)
}

Vue.prototype.myConvertTime = function(date) {
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  return year + '-' + formatTen(month) + '-' + formatTen(day)
}
Vue.prototype.myConvertTimeDetails = function(date) {
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  return year + '-' + formatTen(month) + '-' + formatTen(day) + ' ' + formatTen(date.getHours()) + ':' + formatTen(date.getMinutes()) + ':' + formatTen(date.getSeconds())
}
Vue.prototype.disableDate = function(val) {
  console.log(val)
  if (val) {
    return val.valueOf() > Date.now()
  } else {
    return false
  }
}
Vue.prototype.JsAge = function(str) {
  if (str) {
    try {
      let r = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/)
      if (r == null) return false
      let d = new Date()
      let Y = new Date().getFullYear()
      if (d.getMonth() + 1 > r[3]) {
        return `${Y - r[1] - 1 < 0 ? 0 : Y - r[1]}`
      }
      if (d.getMonth() + 1 < r[3]) {
        return `${Y - r[1] - 1 < 0 ? 0 : Y - r[1] - 1}`
      }
      if (d.getMonth() + 1 == r[3]) {
        if (d.getDate() >= r[4]) {
          return `${Y - r[1] - 1 < 0 ? 0 : Y - r[1]}`
        }
        return `${Y - r[1] - 1 < 0 ? 0 : Y - r[1] - 1}`
      }
      return `${Y - r[1]}`
    } catch (e) {
      console.log(e)
    }
    return ''
  }
  return ''
}
Vue.prototype.sizeToStr = function(size) {
  var data = ''
  if (size < 0.1 * 1024) { //如果小于0.1KB转化成B
    data = size.toFixed(2)
  } else {//如果小于0.1MB转化成KB if (size < 0.1 * 1024 * 1024)
    data = (size / 1024).toFixed(2)
  }
  // else if (size < 0.1 * 1024 * 1024 * 1024) { //如果小于0.1GB转化成MB
  //   data = (size / (1024 * 1024)).toFixed(2);
  // } else { //其他转化成GB
  //   data = (size / (1024 * 1024 * 1024)).toFixed(2);
  // }
  // var sizestr = data + "";
  // var len = sizestr.indexOf("\.");
  // var dec = sizestr.substr(len + 1, 2);
  // if (dec == "00") {//当小数点后为00时 去掉小数部分
  //   return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
  // }
  return data
}
Vue.prototype.FormRules = {
  number: [{
    trigger: ['blur', 'change'],
    validator: (rule, value, callback) => {
      if (value === '') {
        callback(new Error('此处不能为空'))
      } else if (value !== '') {
        if (value > 0) {
          callback()
        } else {
          callback(new Error('请输入数字'))
        }
      } else {
        callback()
      }
    }
  }],//必填
  email: [
    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
  ],//邮箱规则
  gender: [{ required: true, message: '请选择性别', trigger: 'blur' }],//邮箱规则
  oldPassword: [{ required: true, message: '旧密码不能为空', trigger: 'blur' }],//旧密码验证
  password: [
    { required: true, message: '密码不能为空', trigger: 'blur' },
    {
      trigger: ['change'],
      validator: (rule, value, callback) => {
        if (value === '') {
          callback(new Error('密码由6-12位字母、数字组合密码，不分大小写'))
        } else {
          if ($elVue.form.password !== '') {
            // if(/^[a-zA-Z]\w{6,12}$/.test($elVue.form.password)){
            if (/^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/])[\da-zA-Z~!@#$%^&*()_+`\-={}:";'<>?,.\/]{8,}$/.test($elVue.form.password)) {
              callback()
            } else {
              callback(new Error('密码由至少8位字母、数字、特殊字符（除|/[]外）组合密码'))
            }
          }
          callback()
        }
      }
    }
  ],//密码
  idCard: [
    { required: true, message: '身份证不能为空', trigger: 'blur' },
    {
      trigger: ['change'],
      validator: (rule, value, callback) => {
        if (value === '') {
          callback(new Error('身份证不能为空'))
        } else {
          if ($elVue.form.idCard) {
            if (/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test($elVue.form.idCard)) {
              callback()
            } else {
              callback(new Error('请输入正确格式的身份证！'))
            }
          }
          callback()
        }
      }
    }
  ],//身份证
  repassword: [
    { required: true, message: '密码不能为空', trigger: 'blur' },
    {
      trigger: ['change'],
      validator: (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== $elVue.form.password) {
          console.log(value)
          console.log($elVue.form.password)
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
    }
  ],//重复密码
  userName: [
    { required: true, message: '用户名称不能为空', trigger: 'blur' },
    {
      trigger: ['change'],
      validator: (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入用户名称'))
        } else if (value !== '') {
          if (!/^[A-Za-z0-9\u4e00-\u9fa5]{2,12}$/.test(value)) {
            callback(new Error('用户名称由2-12个字符（特殊字符除外）'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    }
  ],//用户名称
  mobile: [
    { required: true, message: '手机号不能为空', trigger: 'change' },
    {
      trigger: ['blur', 'change'],
      validator: (rule, value, callback) => {
        if (value === '') {
          callback(new Error('手机号不能为空'))
        } else if (value !== '') {
          if (!/^(0|86|17951)?(13[0-9]|15[012356789]|17[01678]|18[0-9]|14[57])[0-9]{8}$/.test(value)) {
            callback(new Error('手机号格式有误，请重新输入'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    }
  ],//用户名称
  roleId: [
    { required: true, message: '请选择角色', trigger: 'change' }
  ],//角色
  status: [
    { required: true, message: '状态不能为空', trigger: 'change' }
  ],//角色
  FirstLevelColumnName: [
    {
      trigger: ['change', 'blur'],
      validator: (rule, value, callback) => {
        callback()
      }
    }
  ],//用户名称
  SecondaryColumnName: [
    {
      trigger: ['change', 'blur'],
      validator: (rule, value, callback) => {
        if (value === '') {
          callback(new Error('栏目不能为空'))
        } else if (value === '') {
          callback(new Error('栏目仅限10个字符不支持特殊字符'))
        } else {
          callback()
        }
      }
    }
  ],//用户名称
  roleName: [
    {
      trigger: ['blur', 'change'],
      validator: (rule, value, callback) => {
        if (value === '') {
          callback(new Error('新增名称,限8个字符内(不包含特殊字符)'))
        } else if (value !== '') {
          if (value.length < 8) {
            if (/^[A-Za-z0-9|\u4e00-\u9fa5]{0,8}$/ig.test(value)) {
              callback()
            } else {
              callback(new Error('新增名称,限8个字符内(不包含特殊字符)'))
            }
          } else {
            callback(new Error('新增名称,限8个字符内(不包含特殊字符)'))
          }
        }
      }
    }
  ],
  label1: [
    {
      trigger: ['blur', 'change'],
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入标签！'))
        } else {
          if (value.length > 0 && value.length < 6) {
            if (/^[\u4e00-\u9fa5]{1,6}$/ig.test(value)) {
              callback()
            } else {
              callback(new Error('标签仅限1-6个汉字！'))
            }
          } else {
            callback(new Error('标签仅限1-6个汉字！'))
          }
        }
      }
    }
  ],
  /**新增医生**/
  name: [{ required: true, message: '请输入医师姓名', trigger: 'blur' }],//姓名
  peopleNumber: [{ required: true, message: '请输入咨询人数', trigger: 'blur' }],//姓名
  phone: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],//联系方式
  sex: [{ required: true, message: '请选择性别', trigger: 'blur' }],//性别
  ProvinceAndCity: [{ required: true, message: '请选择医疗机构', trigger: 'blur' }],//医疗机构
  jobCode: [{ required: true, message: '请选择职称', trigger: 'blur' }],//职称
  prac_no: [{ required: true, message: '请输入执业证号', trigger: 'blur' }],//执业证号
  prac_rec_date: [{ required: true, message: '请选择日期', trigger: 'blur' }],//执业证号（含签发日期）
  cert_no: [{ required: true, message: '请输入资格证号', trigger: 'blur' }],//资格证号
  cert_rec_date: [{ required: true, message: '请选择日期', trigger: 'blur' }],//资格证号（含签发日期）
  title_no: [{ required: true, message: '请输入执称证号', trigger: 'blur' }],//执称证号
  title_rec_date: [{ required: true, message: '请选择日期', trigger: 'blur' }],//执称证号（含签发日期）

  desc: [{ required: true, message: '请输入医师简介', trigger: 'blur' }],//医师简介
  goodAt: [{ required: true, message: '请输入医师擅长', trigger: 'blur' }],//医师擅长
  cost: [{ required: true, message: '请输入问诊金额', trigger: 'blur' }],//问诊金额
  prac_type: [{ required: true, message: '请输入执业类别', trigger: 'blur' }],//执业类别
  prac_scope: [{ required: true, message: '请输入执业范围', trigger: 'blur' }],//执业范围
  prac_scope_approval: [{ required: true, message: '请输入审批局规定的医师执业范围', trigger: 'blur' }],//执业范围
  dept: [{ required: true, message: '请选择科室', trigger: 'blur' }],//科室
  idNumber: [{ required: true, message: '请填写身份证号', trigger: 'blur' }],//身份证
  rq: [{ required: true, message: '此处必填', trigger: 'blur' }]//必填
}
Vue.prototype.rolesrouter = [
  {
    path: '/userMent/listUser',//用户管理
    viewpage: false,//是否晒看页面
    roles: [
      { 'type': 'getListUser', name: '查询用户及列表' },
      { type: 'addUser', name: '新増用户' },
      { type: 'modifyUser', name: '修改用户' }
    ]
  },

  {
    path: '/roleMent/listRole',//角色管理
    viewpage: false,//是否晒看页面
    roles: [
      { type: 'getListRole', name: '查看角色及权限' },
      { type: 'addUserRole', name: '新增角色名称及权限' },
      { type: 'modifyUserRole', name: '修改角色名称及权限' }
    ]
  },

  {
    path: '/columnMent/column',//栏目管理
    viewpage: false,//是否晒看页面
    roles: [
      { type: 'getListColumnMent', name: '查询栏目及列表' },
      { type: 'addUserColumnMent', name: '新增栏目' },
      { type: 'modifyColumnMent', name: '编辑栏目' },
      { type: 'deleteColumnMent', name: '删除栏目' }
    ]
  },

  {
    path: '/specialMent/specialMent',//专题管理
    viewpage: false,//是否晒看页面
    roles: [
      { type: 'getListSpecialMent', name: '查看专题' },
      { type: 'addUserSpecialMent', name: '新增专题' },
      { type: 'modifySpecialMent', name: '修改专题' },
      { type: 'deleteSpecialMent', name: '删除专题' }
    ]
  },

  {
    path: '/submitMent/submit',//投稿管理
    viewpage: false,//是否晒看页面
    roles: [
      { type: 'getMyselfSubmit', name: '查询投稿人自有稿件及列表' },
      { type: 'getAllSubmit', name: '查询所有投稿人稿件及列表' },
      { type: 'addSubmit', name: '新增稿件' },
      { type: 'modifySubmit', name: '编辑稿件' },
      { type: 'lookSubmit', name: '预览稿件' },
      { type: 'sendSubmit', name: '投稿稿件' },
      { type: 'rollBackSubmit', name: '撤回稿件' }
    ]
  },

  {
    path: '/submitMent/submit',//投稿管理
    viewpage: false,//是否晒看页面
    roles: [
      { type: 'getMyselfSubmit', name: '查询投稿人自有稿件及列表' },
      { type: 'getAllSubmit', name: '查询所有投稿人稿件及列表' },
      { type: 'addSubmit', name: '新增稿件' },
      { type: 'modifyMyselfSubmit', name: '编辑自有稿件' },
      { type: 'modifyAllSubmit', name: '编辑所有稿件' },
      { type: 'lookSubmit', name: '预览稿件' },
      { type: 'sendSubmit', name: '投稿稿件' },
      { type: 'rollBackSubmit', name: '撤回稿件' }
    ]
  },

  {
    path: '/manuscriptMent/examine',//审核管理
    viewpage: false,//是否晒看页面
    roles: [
      { type: 'getListExamine', name: '查询稿件及列表' },
      { type: 'modifyExamine', name: '编辑稿件' },
      { type: 'isOkExamine', name: '审核稿件' },
      { type: 'lookExamine', name: '查看稿件' },
      { type: 'copyExamine', name: '一键复制' }
    ]
  },

  {
    path: '/manuscriptMent/release',//发布管理
    viewpage: false,//是否晒看页面
    roles: [
      { type: 'getListRelease', name: '查询稿件及列表' },
      { type: 'upDownRelease', name: '发布/下架稿件' },
      { type: 'lookRelease', name: '查看稿件' }
    ]
  },
  {
    path: '/manuscriptMent/recommend',//推荐管理
    viewpage: false,//是否晒看页面
    roles: [
      { type: 'getListRecommend', name: '查询稿件及列表' },
      { type: 'cancelRecommend', name: '推荐/取消推荐稿件' },
      { type: 'setRecommend', name: '设置排序' }
    ]
  }
]
window.editorjuse = {}



// WEBPACK FOOTER //
// ./src/others/Prototype.js